import styles from "./PilotAirdrop.module.css";
import pilotABI from "../../config/pilotABI";
import {PilotChainId, PilotContractAddress, PilotNetwork} from "../../config/config";
import iconMetaMask from "asset/image/pilot/icon_metamask.svg"
import iconDone from "asset/image/pilot/icon-check-circle.png"
import iconError from "asset/image/pilot/icon-error-circle.png"
import iconClose from "asset/icon/ic_close_white_24dp.svg"

import Web3 from "web3";
import {useWeb3React} from "@web3-react/core";
import { InjectedConnector } from '@web3-react/injected-connector';

import {useEffect, useState} from "react";
import pilotAirdropTitleImg from "asset/image/pilot/pilot-airdrop-title.png";
import {useTranslation} from "react-i18next";
import refreshIcon from "../../asset/icon/ic_refresh.svg";
import {Modal} from "@mui/material";


// PilotAirdrop.jsx 내에 추가할 코드
const EIP_6963_REQUEST_PROVIDER = 'eip6963:requestProvider';
// const EIP_6963_PROVIDER_INFO = 'eip6963:providerInfo';
const EIP_6963_ANNOUNCE_PROVIDER = 'eip6963:announceProvider';

// EIP-6963 커넥터 클래스
// class EIP6963Connector extends InjectedConnector {
//     constructor(provider) {
//         super({ supportedChainIds: [1, 3, 4, 5, 42, 56, 97, 137, 80001] });
//         this.provider = provider;
//     }
//
//     async getProvider() {
//         return this.provider;
//     }
// }


const PilotAirdrop = (props) => {

    const { t, i18n } = useTranslation();

    const { language } = props;

    useEffect(() => {
        i18n.changeLanguage(language);
    }, [language]);


    const { active, account, activate, deactivate } = useWeb3React();
    const injectedConnector = new InjectedConnector();

    const [walletAddress, setWalletAddress] = useState("");
    const MINT_LIMIT = 100;
    const [mintableAmount, setMintableAmount] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [isMinting, setIsMinting] = useState(false);
    const [isMintingModalOpen, setIsMintingModalOpen] = useState(false);
    const [mintingModalIcon, setMintingModalIcon] = useState(
        <div className={styles["spinner"]}/>
    );
    const [mintingModalMessage, setMintingModalMessage] = useState(t("PILOT_NOTICE_MINTING"))
    const [isError, setIsError] = useState(false);
    const [buttonFunc, setButtonFunc] = useState(() => () => openWalletModal());

    // EIP-6963 관련 상태
    const [wallets, setWallets] = useState([]);
    const [isWalletModalOpen, setIsWalletModalOpen] = useState(false);
    const [selectedWallet, setSelectedWallet] = useState(null);

    const [web3, setWeb3] = useState(null);

    // const forceMetaMask = async () => {
    //     try {
    //         console.log("메타마스크 연결 시도");
    //
    //         // window.ethereum이 존재하고 MetaMask가 활성화되어 있을 때
    //         if (window.ethereum && window.ethereum.isMetaMask &&
    //             !(window.ethereum.isTrust || window.ethereum.isTrustWallet)) {
    //             // 이미 MetaMask가 활성화되어 있으므로 바로 연결
    //             return true;
    //         }
    //
    //         // 메타마스크 딥링크 사용 시도 (모바일 환경에서만 효과적)
    //         const currentUrl = window.location.href.replace(/^https?:\/\//, '');
    //         window.open('https://metamask.app.link/dapp/' + currentUrl, '_blank');
    //
    //         return false; // 딥링크만 제공하므로 false 반환
    //     } catch (e) {
    //         console.error("메타마스크 연결 시도 오류:", e);
    //         return false;
    //     }
    // };


    // const detectProviderType = (provider) => {
    //     // 트러스트 월렛은 isMetaMask와 isTrust/isTrustWallet 모두 true로 설정하므로
    //     // 먼저 isTrust 또는 isTrustWallet을 확인
    //     if (provider.isTrust || provider.isTrustWallet) {
    //         return 'Trust Wallet';
    //     }
    //
    //     // isMetaMask만 true이면 진짜 메타마스크
    //     if (provider.isMetaMask) {
    //         return 'MetaMask';
    //     }
    //
    //     // 다른 지갑들 확인...
    //     if (provider.isTokenPocket) {
    //         return 'TokenPocket';
    //     }
    //
    //     if (provider.isCoinbaseWallet) {
    //         return 'Coinbase Wallet';
    //     }
    //
    //     return 'Unknown Wallet';
    // };

// 1. EIP-6963 이벤트 리스너 중복 방지 개선
    useEffect(() => {
        // 이미 처리한 지갑 RDNS 추적
        const processedRdns = new Set();
        const discoveredWallets = [];

        // EIP-6963 이벤트 리스너
        const handleAnnounceProvider = (event) => {
            const { info, provider } = event.detail;

            // 이미 처리한 지갑인지 확인 (중복 방지)
            if (processedRdns.has(info.rdns)) {
                return;
            }

            // console.log('EIP-6963 지갑 발견 (중복 제거):', info.name);
            processedRdns.add(info.rdns);

            // 지갑 목록에 추가
            discoveredWallets.push({
                info,
                provider,
                type: 'eip6963'
            });

            setWallets([...discoveredWallets]);
        };
        // 이벤트 리스너 등록
        window.addEventListener(EIP_6963_ANNOUNCE_PROVIDER, handleAnnounceProvider);

        // 지갑 검색 요청
        setTimeout(() => {
            window.dispatchEvent(new Event(EIP_6963_REQUEST_PROVIDER));

            // 검색 완료 후 처리
            setTimeout(() => {
                setIsLoading(false);

                // 기본 window.ethereum 기반 지갑 추가 (필요한 경우)
                if (discoveredWallets.length === 0 && window.ethereum) {
                    // 기존 코드...
                }
            }, 1000);
        }, 500);

        // 컴포넌트 언마운트 시 이벤트 리스너 제거
        return () => {
            window.removeEventListener(EIP_6963_ANNOUNCE_PROVIDER, handleAnnounceProvider);
        };
    }, []);

    // 디버깅용 헬퍼 함수
    // const debugProvider = async (provider, walletName) => {
    //     console.group(`${walletName} 공급자 디버깅`);
    //     console.log('공급자 객체:', provider);
    //
    //     try {
    //         // 체인 ID 확인
    //         const chainId = await provider.request({ method: 'eth_chainId' });
    //         console.log('체인 ID:', chainId, parseInt(chainId, 16));
    //
    //         // 계정 확인 (현재 연결된 계정)
    //         const accounts = await provider.request({ method: 'eth_accounts' });
    //         console.log('현재 계정:', accounts);
    //
    //         // 지원하는 메서드 확인 (일부 지갑만 지원)
    //         if (provider._metamask && provider._metamask.isUnlocked) {
    //             const isUnlocked = await provider._metamask.isUnlocked();
    //             console.log('지갑 잠금 해제 상태:', isUnlocked);
    //         }
    //     } catch (error) {
    //         console.error('공급자 디버깅 오류:', error);
    //     }
    //
    //     console.log('속성:');
    //     console.log('- isMetaMask:', provider.isMetaMask);
    //     console.log('- isTrust:', provider.isTrust);
    //     console.log('- isTrustWallet:', provider.isTrustWallet);
    //     console.log('- isTokenPocket:', provider.isTokenPocket);
    //     console.log('- isCoinbaseWallet:', provider.isCoinbaseWallet);
    //
    //     console.groupEnd();
    // };


// 2. 지갑 연결 함수 개선 - 계정 변경 이벤트 처리 추가
    const connectSpecificWallet = async (wallet) => {
        try {
            setIsLoading(true);
            console.log(`${wallet.name} 지갑에 연결 시도...`);

            // 기존 연결 해제
            if (active) {
                await deactivate();
            }

            // 특정 지갑의 provider 사용
            const provider = wallet.provider;
            await setWeb3(new Web3(provider));

            // 이전 이벤트 리스너 제거 (있는 경우)
            if (window.ethereum && window.ethereum.removeListener) {
                window.ethereum.removeListener('accountsChanged', handleAccountsChanged);
                window.ethereum.removeListener('chainChanged', handleChainChanged);
            }

            // 새 이벤트 리스너 설정
            if (provider.on) {
                provider.on('accountsChanged', handleAccountsChanged);
                provider.on('chainChanged', handleChainChanged);
            }

            // 체인 ID 가져오기
            const chainIdHex = await provider.request({ method: 'eth_chainId' });
            const chainId = parseInt(chainIdHex, 16);

            // console.log("chainId", chainId);

            if(chainId !== parseInt(PilotChainId, 16)) {
                alert(t("PILOT_NOTICE_PLZ_CHANGE_NETWORK"));
                try {
                    await provider.request({
                        method: 'wallet_switchEthereumChain',
                        params: [{ chainId: PilotChainId }],
                    });

                    alert(t("PILOT_NOTICE_CHANGE_NETWORK"))

                }catch (error) {
                    try {
                        await provider.request({
                            method: 'wallet_addEthereumChain',
                            params: [PilotNetwork]
                        });
                    }catch (err){
                        alert(t("PILOT_NOTICE_CHANGE_NETWORK_ERROR"))
                    }
                }
            }

            // 계정 요청 - 직접 provider에서 요청
            // console.log("네트워크 전환 후 지갑 주소 요청 ");
            const accounts = await provider.request({ method: 'eth_requestAccounts' });

            if (!accounts || accounts.length === 0) {
                console.log("계정을 가져올 수 없습니다.");
                throw new Error('계정을 가져올 수 없습니다.');
            }

            // console.log(`${wallet.name} 연결 성공:`, {
            //     account: accounts[0],
            //     chainId
            // });

            // Provider 메타데이터 저장 (나중에 사용하기 위해)
            const walletData = {
                name: wallet.name,
                type: wallet.type,
                chainId,
                address: accounts[0]
            };
            localStorage.setItem('connectedWallet', JSON.stringify(walletData));

            // web3 인스턴스 업데이트 (contract 호출에 사용)
            updateWeb3Instance(provider);

            // 지갑 주소 설정
            await setWalletAddress(accounts[0]);
            await setIsError(false);
            await callMintable();

            return true;
        } catch (error) {
            alert(`${wallet.name} ${t("PILOT_NOTICE_WALLET_CONNECT_ERROR")}`);

            switch (error.code) {
                case 4001 :
            //         TODO: 유저가 요청을 취소함
                    break;
                case -32002 :
                    // TODO: 이미 연결 시도 중
                    break;
            }
            console.error(`${wallet.name} 연결 오류:`, error);
            setIsError(true);
            return false;
        } finally {
            setIsLoading(false);
            closeWalletModal();
        }
    };

// 계정 변경 이벤트 핸들러
    const handleAccountsChanged = async (accounts) => {
        console.log('계정 변경됨:', accounts);
        if (accounts.length === 0) {
            // 연결 해제됨
            await setWalletAddress('');
            // 다른 상태 초기화...
        } else {
            // 새 계정으로 업데이트
            await setWalletAddress(accounts[0]);
            // 필요한 경우 다시 정보 로드
            if (accounts[0]) {
                try {
                    await callMintable();
                } catch (e) {
                    console.error('민팅 가능 수량 조회 오류:', e);
                }
            }
        }
    };


// 체인 변경 이벤트 핸들러
    const handleChainChanged = async (chainId) => {
        // console.log('체인 변경됨:', chainId, parseInt(chainId, 16));
        // 필요한 경우 체인 ID 관련 로직 추가
        if(chainId !== PilotChainId) {
            await alert(t("PILOT_NOTICE_CHAIN_CHANGE_DETECTED"));
            window.location.reload(); // 또는 상태 업데이트로 처리
        }
    };

// Web3 인스턴스 업데이트 (특정 provider 사용)
    const updateWeb3Instance = (provider) => {
        // 새로운 Web3 인스턴스 생성
        const web3 = new Web3(provider);

        // 글로벌 변수로 저장하거나 상태로 관리
        window.currentWeb3 = web3;

        return web3;
    };

    // useEffect(() => {
    //     setWeb3(updateWeb3Instance);
    // }, [updateWeb3Instance])


    // 월렛 로고 가져오기
    // const getWalletLogo = (rdns) => {
    //     if (rdns.includes('metamask')) return '/images/wallets/metamask.png';
    //     if (rdns.includes('coinbase')) return '/images/wallets/coinbase.png';
    //     if (rdns.includes('trust')) return '/images/wallets/trust.png';
    //     if (rdns.includes('brave')) return '/images/wallets/brave.png';
    //     return '/images/wallets/default-wallet.png';
    // };

    const openWalletModal = () => {
        setIsWalletModalOpen(true);
    };

    const closeWalletModal = () => {
        setIsLoading(false);
        setIsWalletModalOpen(false);
    };

    const handleClickMintingModalCloseBtn = () => {
        if(isMinting){
            return;
        }

        setIsMintingModalOpen(false);
    }


    // EIP-6963 지갑 연결
    // const connectEIP6963Wallet = async (wallet) => {
    //     try {
    //         setIsLoading(true);
    //         setSelectedWallet(wallet);
    //
    //         await deactivate();
    //
    //         const connector = new EIP6963Connector(wallet.provider);
    //         await activate(connector, undefined, true);
    //
    //         const provider = await connector.getProvider();
    //         const accounts = await provider.request({ method: 'eth_requestAccounts' });
    //
    //         console.log('지갑 연결됨:', accounts[0], '(', wallet.info.name, ')');
    //         await setWalletAddress(accounts[0]);
    //
    //         // 모달 닫기
    //         closeWalletModal();
    //
    //         // 로컬 스토리지에 선택한 지갑 정보 저장 (선택 사항)
    //         localStorage.setItem('selectedWalletRdns', wallet.info.rdns);
    //     } catch (error) {
    //         console.error('지갑 연결 오류:', error);
    //         setIsError(true);
    //     } finally {
    //         setIsLoading(false);
    //     }
    // };

    // 기존 injected 지갑 연결 (하위 호환성)
    // const connectInjectedWallet = async () => {
    //     try {
    //         setIsLoading(true);
    //
    //         await deactivate();
    //         await activate(injectedConnector);
    //
    //         const provider = await injectedConnector.getProvider();
    //         const accounts = await provider.request({ method: 'eth_requestAccounts' });
    //
    //         console.log('지갑 연결됨:', accounts[0]);
    //         await setWalletAddress(accounts[0]);
    //
    //         closeWalletModal();
    //     } catch (error) {
    //         console.error('지갑 연결 오류:', error);
    //         setIsError(true);
    //     } finally {
    //         setIsLoading(false);
    //     }
    // };

    /**
     * 민팅 가능한 개수를 불러오는 함수
     * @returns {Promise<void>}
     */
    const callMintable = async () => {
        setIsLoading(true);

        if(!walletAddress){
            return;
        }

        try {
            // const provider = new Web3(window.ethereum);
            const provider = web3;
            // console.log("callMintable web3 provider :", provider);
            const contract = new provider.eth.Contract(pilotABI, PilotContractAddress);

            const amount = await contract.methods.remainingAllocation(walletAddress).call();
            // console.log("remainingAllocation에서 가져온 amount: ", amount);
            setMintableAmount(Number(amount));
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    /**
     * 구매 가능한 nft를 모두 민팅하는 함수
     * @returns {Promise<void>}
     */
    const callMintAll = async () => {
        if (!window.ethereum) {
            // alert("지갑이 연결되지 않았습니다.");
            return;
        }

        // console.log("민팅 함수 호출");
        setIsMinting(true);
        setIsMintingModalOpen(true);
        setMintingModalMessage(t("PILOT_NOTICE_MINTING"));
        setMintingModalIcon(<div className={styles["spinner"]}/>);

        if (mintableAmount <= 0) {
            setIsMinting(false);
            setIsMintingModalOpen(false);
            return;
        }

        try {
            // const provider = new Web3(window.ethereum);
            const provider = web3;
            const contract = new provider.eth.Contract(pilotABI, PilotContractAddress);

            const amount = Number(mintableAmount) <= Number(MINT_LIMIT) ? Number(mintableAmount) : Number(MINT_LIMIT);

            if (amount <= 0) {
                return;
            }

            // 현재 네트워크의 평균 가스 가격(wei 단위)
            const currentGasPrice = await provider.eth.getGasPrice();
            // console.log(`현재 가스 가격: ${provider.utils.fromWei(gasPrice, 'gwei')} gwei`);
            const gasPrice = Math.floor(currentGasPrice * 1.2);

            // 가스 사용량 추정
            const gasEstimate = await contract.methods.mintPartial(Number(amount)).estimateGas({
                from: walletAddress
            });

            // 사용 가스 한도를 1.2배로 여유분 설정 -> 실패 X, 사용되지 않은 가스는 환불됨
            const gasLimit = Math.floor(gasEstimate * 1.2);

            // console.log(`추정 가스 사용량: ${gasEstimate}, 설정 가스 한도: ${gasLimit}`);

            // const data = await contract.methods.mintPartial(Number(amount)).send({
            //     from: walletAddress,
            //     gasPrice: provider.utils.toWei(0.01, 'gwei'),
            //     gas : gasLimit
            // });

            const data = await contract.methods.mintPartial(Number(amount)).send({
                from: walletAddress,
                gasPrice: gasPrice,
                gas: gasLimit
            });

            // console.log("민팅 성공");
            // console.log(data);
            // console.log("트랜잭션 해시: ", data.transactionHash);

            setMintingModalIcon(<img width={20} src={iconDone}></img>);
            setMintingModalMessage(t("PILOT_NOTICE_MINTING_SUCCESS", {amount : amount}));

            await callMintable();
        } catch (error) {
            console.log(error);
            // alert(`사용자가 요청을 취소했습니다.\nUser denied transaction signature.`);
            setMintingModalIcon(<img width={20} src={iconError}></img>);
            setMintingModalMessage(t("PILOT_NOTICE_MINTING_CANCELED"));

            // console.log("민팅 실패");
            // console.error(error);
        } finally {
            setIsMinting(false);
        }
    };

    useEffect(() => {
        if (!walletAddress) {
            return;
        }

        callMintable()
            .then(() => {
                setButtonFunc(() => () => callMintAll());
            })
            .catch((error) => {
                console.error(error);
            });

    }, [walletAddress, mintableAmount]);

    // 상단 안내 메시지
    const InfoMessage = () => {
        if (isLoading) {
            return t("PILOT_NOTICE_CONNECTING_WALLET");
        }

        if (isError) {
            return t("PILOT_NOTICE_WALLET_CONNECT_ERROR");
        }

        if (!walletAddress) {
            return t("PILOT_NOTICE_PLZ_CONNECT_WALLET_FIRST");
        }

        return t("PILOT_NOTICE_WALLET_CONNECTED")
    };

    // 버튼 메시지
    const BtnMessage = () => {
        if (isLoading) {
            return t("PILOT_NOTICE_WALLET_CONNECTED");
        }

        if (isError) {
            return "파일럿을 받을 수 없습니다.";
        }

        if (!walletAddress) {
            return t("PILOT_BTN_CONNECT_WALLET");
        }

        if (mintableAmount <= 0) {
            return t("PILOT_BTN_NO_AIRDROP");
        }

        return t("PILOT_BTN_CLAIM_AIRDROP");
    };

    // 지갑 선택 모달 컴포넌트
    const WalletSelectionModal = () => {
        const [discoveredWallets, setDiscoveredWallets] = useState([]);
        const [installedWallets, setInstalledWallets] = useState([]);
        const [isWalletListLoading, setIsWalletListLoading] = useState(true);

        // 지갑 아이콘 매핑
        const walletIcons = {
            MetaMask: '/images/wallets/metamask.png',
            'Trust Wallet': '/images/wallets/trust.png',
            Rainbow: '/images/wallets/rainbow.png',
            'Coinbase Wallet': '/images/wallets/coinbase.png',
            WalletConnect: '/images/wallets/walletconnect.png',
            Argent: '/images/wallets/argent.png',
            Omni: '/images/wallets/omni.png',
            imToken: '/images/wallets/imtoken.png',
            Default: '/images/wallets/default-wallet.png'
        };

        // 지갑 검출 함수
        useEffect(() => {
            // EIP-6963 지갑 검출
            const wallets = [];

            // EIP-6963 이벤트 리스너
            const handleAnnounceProvider = (event) => {

                const ALLOWED_WALLETS = [
                    "MetaMask",
                    "Trust Wallet",
                    "OKX Wallet",
                    "Rabby Wallet"
                ]
                const { info, provider } = event.detail;
                // console.log('EIP-6963 지갑 발견:', info.name);

                // TODO: 정해진 지갑 종류가 아니면 목록에 추가되지 않도록 걸러내기
                if(!ALLOWED_WALLETS.includes(info.name)) {
                    return;
                }

                // 중복 방지
                if (!wallets.some(wallet => wallet.info.rdns === info.rdns)) {
                    wallets.push({
                        info,
                        provider,
                        type: 'eip6963'
                    });
                    setDiscoveredWallets([...wallets]);
                }
            };

            window.addEventListener(EIP_6963_ANNOUNCE_PROVIDER, handleAnnounceProvider);
            window.dispatchEvent(new Event(EIP_6963_REQUEST_PROVIDER));

            // 기존 방식으로 설치된 지갑 검출 (window.ethereum)
            setTimeout(() => {
                // 기존 window.ethereum 검출
                const detectedWallets = [];

                if (window.ethereum) {
                    // MetaMask
                    if (window.ethereum.isMetaMask && !(window.ethereum.isTrust || window.ethereum.isTrustWallet)) {
                        detectedWallets.push({
                            name: 'MetaMask',
                            provider: window.ethereum,
                            type: 'injected'
                        });
                    }

                    // Trust Wallet
                    if (window.ethereum.isTrust || window.ethereum.isTrustWallet) {
                        detectedWallets.push({
                            name: 'Trust Wallet',
                            provider: window.ethereum,
                            type: 'injected'
                        });
                    }

                    // Coinbase Wallet
                    if (window.ethereum.isCoinbaseWallet) {
                        detectedWallets.push({
                            name: 'Coinbase Wallet',
                            provider: window.ethereum,
                            type: 'injected'
                        });
                    }

                    // 그 외 지갑
                    if (detectedWallets.length === 0) {
                        detectedWallets.push({
                            name: '브라우저 지갑',
                            provider: window.ethereum,
                            type: 'injected'
                        });
                    }
                }

                // providers 배열이 있는 경우
                if (window.ethereum?.providers) {
                    for (const provider of window.ethereum.providers) {
                        if (provider.isMetaMask && !detectedWallets.some(w => w.name === 'MetaMask')) {
                            detectedWallets.push({
                                name: 'MetaMask',
                                provider,
                                type: 'injected'
                            });
                        }

                        if ((provider.isTrust || provider.isTrustWallet) && !detectedWallets.some(w => w.name === 'Trust Wallet')) {
                            detectedWallets.push({
                                name: 'Trust Wallet',
                                provider,
                                type: 'injected'
                            });
                        }

                        if (provider.isCoinbaseWallet && !detectedWallets.some(w => w.name === 'Coinbase Wallet')) {
                            detectedWallets.push({
                                name: 'Coinbase Wallet',
                                provider,
                                type: 'injected'
                            });
                        }
                    }
                }

                setInstalledWallets(detectedWallets);
                setIsWalletListLoading(false);
            }, 500);

            return () => {
                window.removeEventListener(EIP_6963_ANNOUNCE_PROVIDER, handleAnnounceProvider);
            };
        }, []);

        // 모든 지갑 목록 (EIP-6963 + 기존 방식)
        const allWallets = [...discoveredWallets.map(w => ({
            name: w.info.name,
            icon: w.info.icon || walletIcons[w.info.name] || walletIcons.Default,
            provider: w.provider,
            type: w.type
        })), ...installedWallets.map(w => ({
            name: w.name,
            icon: walletIcons[w.name] || walletIcons.Default,
            provider: w.provider,
            type: w.type
        }))];

        // 중복 제거
        const uniqueWallets = allWallets.filter((wallet, index, self) =>
            index === self.findIndex((w) => w.name === wallet.name)
        );

        // 지갑 연결
        // const handleWalletConnect = async (wallet) => {
        //     try {
        //         setIsLoading(true);
        //
        //         if (wallet.type === 'eip6963') {
        //             // EIP-6963 지갑
        //             const connector = new EIP6963Connector(wallet.provider);
        //             await activate(connector);
        //
        //             const accounts = await wallet.provider.request({ method: 'eth_requestAccounts' });
        //             console.log(`${wallet.name} 지갑 연결됨:`, accounts[0]);
        //             await setWalletAddress(accounts[0]);
        //         } else {
        //             // 기존 방식
        //             const provider = wallet.provider;
        //             const accounts = await provider.request({ method: 'eth_requestAccounts' });
        //
        //             const connector = new InjectedConnector();
        //             await activate(connector);
        //
        //             console.log(`${wallet.name} 지갑 연결됨:`, accounts[0]);
        //             await setWalletAddress(accounts[0]);
        //         }
        //
        //         closeWalletModal();
        //     } catch (error) {
        //         console.error('지갑 연결 오류:', error);
        //         setIsError(true);
        //     } finally {
        //         setIsLoading(false);
        //     }
        // };

        // 지갑 감지 함수에서 handleWalletConnect 함수 수정
        const handleWalletConnect = (wallet) => {
            connectSpecificWallet(wallet);
        };

        // UI 스타일 - 레인보우킷 스타일 모방
        const categoryStyle = {
            fontSize: '14px',
            color: '#8f9097',
            marginBottom: '12px',
            marginTop: '20px'
        };

        const walletListStyle = {
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            marginBottom: '10px'
        };

        const walletItemStyle = {
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            padding: '12px 16px',
            borderRadius: '12px',
            cursor: 'pointer',
            transition: 'background 0.2s',
            background: 'rgba(255, 255, 255, 0.07)'
        };

        const walletIconStyle = {
            width: '32px',
            height: '32px',
            borderRadius: '8px',
            objectFit: 'contain'
        };

        const walletNameStyle = {
            color: '#fff',
            fontSize: '16px',
            fontWeight: '500'
        };

        return (
            <Modal
                open={isWalletModalOpen}
                onClose={closeWalletModal}
                className={styles["wallet-modal"]}
                style={{zIndex : 99999999}}
            >
                <div className={styles["wallet-modal-content"]} style={{ maxWidth: '360px', maxHeight: '85vh', scrollbarWidth : "none"}}>
                    <div className={styles["wallet-modal-header"]}>
                        <h2>
                            {
                                t("WALLET_CONNECT")
                            }
                        </h2>
                        <button className={styles["close-btn"]} onClick={closeWalletModal}>×</button>
                    </div>

                    {isWalletListLoading ? (
                        <div style={{ textAlign: 'center', padding: '30px 0' }}>
                            <div className={styles["wallet-select-spinner"]} style={{ margin: '0 auto' }}/>
                            <p style={{ marginTop: '15px' }}>
                                {
                                    t("SEARCHING_FOR_WALLETS")
                                }
                            </p>
                        </div>
                    ) : (
                        isLoading ?
                            <div style={{ textAlign: 'center', padding: '30px 0' }}>
                                <div className={styles["wallet-select-spinner"]} style={{ margin: '0 auto' }}/>
                                <p style={{ marginTop: '15px' }}>
                                    {
                                        t("WAITING_FOR_WALLET_CONNECT")
                                    }
                                </p>
                            </div>
                            :
                            <div>
                            {/* 최근 사용 지갑 (예시) */}
                            {localStorage.getItem('lastConnectedWallet') && (
                                <>
                                    <div style={categoryStyle}>최근 사용</div>
                                    <div style={walletListStyle}>
                                        {/* 최근 연결한 지갑 표시 */}
                                    </div>
                                </>
                            )}

                            {/* 설치된 지갑 목록 */}
                            <div style={categoryStyle}>
                                {
                                    t("INSTALLED")
                                }
                            </div>
                            <div style={walletListStyle}>
                                {uniqueWallets.length > 0 ? (
                                    uniqueWallets.map((wallet, index) => (
                                        <div
                                            key={`${wallet.name}-${index}`}
                                            style={walletItemStyle}
                                            onClick={() => handleWalletConnect(wallet)}
                                        >
                                            <img
                                                src={wallet.icon}
                                                alt={wallet.name}
                                                style={walletIconStyle}
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = walletIcons.Default;
                                                }}
                                            />
                                            <span style={walletNameStyle}>{wallet.name}</span>
                                        </div>
                                    ))
                                ) : (
                                    <div style={{ textAlign: 'center', padding: '15px', color: '#8f9097' }}>
                                        {
                                            t("NO_WALLET_INSTALLED")
                                        }
                                    </div>
                                )}
                            </div>

                             {/*기타 지갑 목록 (옵션)*/}

                            {
                                uniqueWallets.length <= 0 &&
                                <>
                                <div style={categoryStyle}>
                                    {
                                        t("ETC")
                                    }
                                </div>
                                <div style={walletListStyle}>
                                <div
                                    style={walletItemStyle}
                                    onClick={() =>   window.open(
                                        'https://metamask.io/download', "_blank")
                                    }
                                >
                                    <img
                                        src={iconMetaMask}
                                        alt="WalletConnect"
                                        style={walletIconStyle}
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = walletIcons.Default;
                                        }}
                                    />
                                    <span style={walletNameStyle}>Install MetaMask</span>
                                </div>
                            </div>
                                </>

                            }

                        </div>
                    )}
                </div>
            </Modal>
        );
    };


    return (
        <div className={styles["pilot-airdrop"]}>
            <section className={styles["title-container"]}>
                <div className={styles["badge"]}>
                    NOW
                </div>

                <div className={styles["pilot-airdrop-title"]}>
                    <img src={pilotAirdropTitleImg} alt=""/>
                    <div className={styles["glow"]}></div>
                </div>
            </section>

            <div className={styles["wrap"]}>
                <div className={styles["info-container"]}>
                    <div className={styles["desc"]}>
                        <InfoMessage/>
                    </div>

                    <div className={styles["wallet-container"]} style={{display: isLoading || isError || !walletAddress ? "none" : "flex"}} >
                        <div className={styles["desc"]}>
                            {
                                t("PILOT_NOTICE_CONNECTED_WALLET_ADDRESS")
                            }
                        </div>

                        <div className={styles["wallet-address"]}>
                            {walletAddress}
                        </div>

                        <div className={styles["ticket-amount"]}>
                            <div className={styles["ticket-amount-text"]}>
                                {t("AIRDROP_AMOUNT")}
                            </div>

                            <div className={styles["separator"]}/>

                            <strong>
                                {mintableAmount}
                            </strong>
                        </div>
                    </div>

                    <div className={styles["retry-btn"]}
                         onClick={openWalletModal}
                         style={{display: isError && !isLoading ? "flex" : "none"}}
                    >
                        <img src={refreshIcon} alt="" style={{width: 20}}/>
                        {t("RETRY")}
                    </div>

                    <div className={styles["loading-container"]} style={{display: isLoading ? "flex" : "none"}} >
                        <div className={styles["spinner"]}/>
                    </div>
                </div>

                <button type={"button"} className={`
                    ${styles["pilot-airdrop-connect-btn"]} 
                    ${isLoading || isError || (walletAddress && mintableAmount <= 0) ? styles["loading"] : ""}
                `}
                        onClick={buttonFunc}
                        disabled={isMinting}
                >
                    <BtnMessage/>
                </button>
            </div>

            <section className={styles["bottom-glow-container"]}>
                <div className={styles["glow1"]}/>
                <div className={styles["glow2"]}/>
                <div className={styles["glow3"]}/>
            </section>

            {/* 민팅 로딩 모달 */}
            {isMintingModalOpen &&
                <Modal open={isMintingModalOpen}
                       onClose={() => {}}
                       className={styles["pilot-minting-modal"]}
                       style={{zIndex: 99999999}}
                >
                    <div className={styles["pilot-minting-modal-content"]}>
                        <div
                            className={styles["pilot-minting-modal-content-header"]}
                            onClick={handleClickMintingModalCloseBtn}
                        >
                            <img src={iconClose} alt="" style={{visibility: isMinting ? "hidden" : "visible"}}/>
                        </div>

                        { mintingModalIcon }
                        { mintingModalMessage }
                    </div>
                </Modal>
            }

            {/* 지갑 선택 모달 */}
            <WalletSelectionModal />
        </div>
    );
};

export default PilotAirdrop;